<div class="white-box main-black border-radius content">
	<app-truck-summary-report-header [siteInfo]="siteInfo" [totalTrucks]="totalTrucks" [selectedPeriodFormatted]="selectedPeriodFormatted"></app-truck-summary-report-header>
	<div class="white-box main-black  border-radius">
		<h1 class="h3 m-4">{{'utilization.site_performance_scores' | translate}}</h1>
		<app-truck-summary-report-performance [data]="data" [period]="period" [selectedDays]="selectedDays" [totalTrucks]="totalTrucks"></app-truck-summary-report-performance>	
	</div>
	<div class="white-box main-black  border-radius">
		<h1 class="h3 m-4">{{'utilization.truck_fleet_activity_metrics' | translate}}</h1>
		<app-truck-fleet-usage-summary [data]="data" [period]="period" [selectedDays]="selectedDays" [showLegend]="true" [forAnalytics]="true" [showFooterDate]="true"></app-truck-fleet-usage-summary>
	</div>
</div>